module.exports = __webpack_public_path__ + "static/background_2020.9b904c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background_2020.png
// module id = 25
// module chunks = 77068110949488 114276838955818 152176518627018 232863481103816